import React, { Component } from 'react';
import $ from 'jquery';

class DoctorPage extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }

    componentDidMount(){
        $("#visit").click(function() {
            $('html, body').animate({
                scrollTop: $("#contact-form").offset().top
            }, 1500);
        });
    }

    render() { 
        return (
            <div>
            <section id="top-medic" style={{backgroundImage: "url('/assets/images/medico.jpeg')", backgroundPosition: "center -50%"}}>
                <div class="top-content">
                    <div class="blues-content">
                        <div class="t-middle">
                            <div class="t-middle__content">
                                <div class="mB-30 mT-30">
                                    <h3 style={{fontSize: 25}} class="dark-blue m-0"><b>Blues, aqui começa uma nova parceria do nosso sucesso!</b></h3>
                                </div>
                            </div>
                            <div class="t-middle__content">
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section id="welcome">
                <div class="peers w-100p h-100p jc-sb">
                    <div class="blues-content">
                        <h2 class="ta-c c-client-default">Juntos faremos o melhor para o <br/> nosso paciente!</h2>
                        <div class="center-text">
                            <h5>Agora você já tem sua clínica de fisioterapia na palma da mão, com um sistema simples e fácil de
                                acessar em qualquer lugar. Com a Blues, desde a primeira consulta promoveremos a integração entre o
                                médico e o fisioterapeuta. Queremos uma parceria com você, para que juntos possamos acompanhar a
                                progressão do paciente.</h5>
                        </div>
                    </div>
                </div>
            </section>
            <section id="banner-action">
                    <div class="banner-action-middle">
                
                
                        <div class="banner-action-middle__content">
                            <div class="">
                                <div class="right bgc-grey-100 h-middle sz-500 p-30">
                                    <div>
                                        <div class="banner-d-flex mT-30">
                                            <div class="medium-icon">
                                                <img src="/assets/images/icons/stethoscope.svg"/>
                                            </div>
                                            <h5 class="mL-20 pR-30">Buscamos uma relação direta e de longo prazo com
                                                os médicos,
                                                pois entendemos que quanto melhor a sinergia
                                                entre os profissionais
                                                de Medicina e Fisioterapia, melhor
                                                será o resultado do tratamento.
                
                                            </h5>
                
                
                                        </div>
                                        <div class="ta-c peers jc-c">
                                            <button id="visit" type="button"
                                                class="btn btn-outline-quartenary fsz-md bdr-full  mT-30 pX-30 pY-10 big-button-text">
                                                Profissional da Saúde? <b>Receba uma visita</b>
                                            </button>
                                        </div>
                
                                    </div>
                                </div>
                
                            </div>
                
                        </div>
                        <div class="banner-action-middle__content banner-image"
                            style={{backgroundImage: "url('/assets/images/img01.jpg')"}}>
                
                        </div>
                
                    </div>
                </section>
                

            <section id="about">
                <div class="peers w-100p h-100p jc-sb">
                    <div class="blues-content">
                        <h2 class="ta-c c-client-default">Por que a <b>Blues </b> é diferente?</h2>
                        <h5 class="ta-c">Oferecemos um atendimento humanizado, sem olhar apenas para uma lesão, mas para
                                o paciente como um todo, no âmbito biopsicossocial. Em um ambiente padronizado e organizado
                                para receber seus pacientes. Ao final de cada sessão, o paciente também nos avalia,
                                cadastrando sua percepção em nosso sistema.</h5>
                        <div class="two-content mT-50">
                            <div class="two-content__block mB-20 card">
                                <div class="pX-20 h-100p pT-20">
                                    <div class="medium-icon">
                                        <img src="/assets/images/icons/medical-history.svg" />
                                    </div>
                                    <h5 class="c-client-default ta-c">Focamos no resultado</h5>
                                    <p class="ta-c">Esse é o nosso DNA. Focamos desde o primeiro atendimento em atingir os melhores
                                        resultados, com isso proporcionando bem estar e retorno às atividades o quanto antes.</p>
                                </div>
                            </div>

                            <div class="two-content__block mB-20 card">
                                <div class="pX-20 h-100p pT-20">
                                    <div class="medium-icon">
                                        <img src="/assets/images/icons/graduation.svg" />
                                    </div>
                                    <h5 class="c-client-default ta-c">Exigimos muito a qualificação técnica da equipe</h5>
                                    <p class="ta-c">Temos uma equipe altamente qualificada, com alguns requisitos mínimos para
                                        contratação: 5 anos de formado, pós-graduação e cursos de aperfeiçoamento.</p>
                                </div>
                            </div>

                            <div class="two-content__block mB-20 card">
                                <div class="pX-20 h-100p pT-20">
                                    <div class="medium-icon">
                                        <img src="/assets/images/icons/collaboration.svg" />
                                    </div>
                                    <h5 class="c-client-default ta-c">Adoramos tecnologia e inovação</h5>
                                    <p class="ta-c">Somos sua clínica virtual. Através do Sistema Blues você acompanha o tratamento
                                        da avaliação até a alta, e pode trocar informações com a gente no canal de comunicação
                                        médico/fisioterapeuta.</p>
                                </div>


                            </div>
                        </div>
                        <h2 class="c-client-default ta-c">Cuidamos do paciente com profissionalismo</h2>
                    </div>
                </div>
            </section>
            {/*<section id="blog-action" class="bgc-blue-50">
                <div class="peers w-100p h-100p jc-sb">
                    <div class="blues-content">
                        <div class="t-middle">
                            <div class="t-middle__content">
                                <div class="right">
                                    <h2 class="c-client-default m-0"><b class="c-client-default">#NósCuidamos</b></h2>
                                    <h5 class=" m-0">Acompanhe todas as novidades da Blues em nosso Blog, além de
                                        informações e dicas sobre sua saúde e bem-estar.</h5>
                                </div>
                            </div>
                            <div class="t-middle__content">
                                <a href="/#/blog" class="btn btn-quartenary fsz-md bdr-full pX-30 pY-10">
                                    <b>BLOG da Blues</b>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
        </section>*/}
            <section id="contact-form" class="bgc-grey-100">
                <div class="peers w-100p h-100p jc-sb">
                    <div class="blues-content">
                        <div class="t-middle">
                            <div class="t-middle__content t-top">
                                <div class="right">
                                    <h2 class="c-client-default-tertiary m-0"><b>Está na hora de sorrir!</b></h2>
                                    <h5 class="c-client-default m-0">
                                        E se restou alguma dúvida, estamos aqui para esclarecer!</h5>
                                </div>
                            </div>
                            <div class="t-middle__content">
                                <form id="form-home">
                                    <div class="mB-10">
                                        <label>Nome completo</label>
                                        <input type="text" placeholder="nome" />
                                    </div>
                                    <div class="mB-10">
                                        <label>Telefone</label>
                                        <input type="text" placeholder="telefone" />
                                    </div>
                                    <div class="mB-10">
                                        <label>E-mail</label>
                                        <input type="text" placeholder="E-mail" />
                                    </div>
                                    <div class="mB-10">
                                        <label>Assunto</label>
                                        <textarea type="text" placeholder="Assunto"></textarea>
                                    </div>
                                    <div class="ta-c">
                                        <button type="submit" class="btn btn-quartenary fsz-md bdr-full  mT-10 pX-30 pY-10">
                                            <b>ENVIAR</b>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        );
    }
}
 
export default DoctorPage;


// WEBPACK FOOTER //
// ./src/pages/home/pages/Doctor.js